<template lang="pug">
    Tabs(type="card" style="background: #e3e8ee;padding:16px;")
        TabPane(:label='$t("accountInfo.plan.usageAmountText")')
            //- p(v-if="objData.length == 0") {{ $t('accountInfo.noDataText') }}
            Table( max-height="500" :columns="qtyColumns" :data="userItmeLogObj" :disabled-hover="true" show-summary :summary-method="handleCurrentAmount" )
                template(slot-scope="{row}" slot="items")
                    div(v-for="item in row.items" :key="row.itemId")
                        span {{item.ItemName}}
                template(slot-scope="{row}" slot="useDay")
                    div(v-if="row.up_to")
                        span(v-if="row.useDay>0" style="text-decoration: line-through;") {{separator(row.useDay)}} 
                        span &emsp;
                        span(v-if="row.useDay-row.up_to>0") {{separator(row.useDay-row.up_to)}}
                        span(v-else) 0
                    div(v-else)
                        span {{row.useDay}} 
        TabPane(:label='$t("accountInfo.plan.ResourceText")')
            //- p(v-if="objData.length == 0") {{ $t('accountInfo.noDataText') }}
            Table( max-height="500" :columns="objColumns" :data="objData" show-summary :disabled-hover="true")
                template(slot-scope="{row}" slot="itemName")
                    span(v-if="row.itemName == 'basic' || row.itemName == 'pro'") {{$t("accountInfo."+row.itemName)}} 
                    span(v-else) {{row.itemName}} 
</template>

<script>
export default {
    name: "PaymentObjectTabs",
    components: {},
    data() {
        return {
            isLoading: false,
            objColumns: [
                { title: "ItemName", align: "center", key: "itemName", slot: "itemName" },
                { title: "StartDate", align: "center", key: "from" },
                { title: "EndDate", align: "center", key: "to" },
                { title: "UseDay", align: "center", key: "days" },
            ],
            qtyColumns: [
                { title: "RecordDate", align: "center", key: "recordDate" },
                // { title: "Items", align: "center", key: "items", slot: "items" },
                { title: "Qty", align: "center", key: "useDay", slot: "useDay" },
            ],
        };
    },
    props: {
        shape: { default: "circle" },
        objData: { title: "", align: "center", key: "" },
        userItmeLogObj: {},
    },
    watch: {},
    created() {},
    mounted() {},
    methods: {
        handleCurrentAmount({ columns, data }) {
            const sums = {};
            columns.forEach((column, index) => {
                const key = column.key;
                if (index === 0) {
                    sums[key] = {
                        key,
                        value: this.$t("accountInfo.plan.totalText"),
                    };
                    return;
                }
                const values = data.map((item) => Number(item[key]));
                if (index === 1) {
                    let total = 0;
                    data.forEach((e) => {
                        let upTo = e.up_to ? e.up_to : 0;
                        if (e.useDay - upTo > 0) {
                            total += e.useDay - upTo;
                        }
                    });

                    sums[key] = {
                        key,
                        value: this.separator(total),
                    };
                } else {
                    sums[key] = {
                        key,
                        value: "",
                    };
                }
            });

            return sums;
        },
        separator(numb) {
            var str = numb.toString().split(".");
            str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return str.join(".");
        },
    },
    computed: {},
    beforeDestroy() {},
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/PaymentObjectTabs.vue